import { useMemo, useState } from "react";
import type { ChangeEvent } from "react";
import type { NatureR01Candidate, NatureR01Result } from "./natureR01.types";
import { buildNatureR01Result, similarityLabel } from "./natureR01.service";

const DEMO_CANDIDATES: NatureR01Candidate[] = [
  { species: "Peperomia graveolens", similarity: 0.9522 },
  { species: "Carex pygmaea", similarity: 0.7622 },
  { species: "Berberis rigida", similarity: 0.7587 },
];

export function NatureR01Panel() {
  const [selectedFileName, setSelectedFileName] = useState<string>("");
  const [result, setResult] = useState<NatureR01Result | null>(null);

  const topCandidate = useMemo(
    () => result?.candidates[0] ?? null,
    [result],
  );

  function handleFileChange(event: ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0] ?? null;

    setSelectedFileName(file?.name ?? "");
    setResult(null);
  }

  function handleExperimentalAnalysis() {
    const nextResult = buildNatureR01Result(
      DEMO_CANDIDATES,
      "unknown",
    );

    setResult(nextResult);
  }

  return (
    <section
      className="thera-nature-r01"
      aria-labelledby="thera-nature-r01-title"
    >
      <header>
        <p className="eyebrow">THERA Nature IA · R0.1 privado</p>
        <h2 id="thera-nature-r01-title">Identificación visual experimental</h2>
        <p>
          Herramienta privada de apoyo para pruebas de campo.
          Los resultados requieren verificación.
        </p>
      </header>

      <div>
        <label>
          Seleccionar fotografía
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </label>

        {selectedFileName && (
          <p>
            Foto seleccionada: <strong>{selectedFileName}</strong>
          </p>
        )}

        <button
          type="button"
          onClick={handleExperimentalAnalysis}
          disabled={!selectedFileName}
        >
          Analizar con R0.1
        </button>
      </div>

      {result && topCandidate && (
        <div>
          <p>
            Estado: <strong>{result.status}</strong>
          </p>

          <h3>Posible coincidencia: {topCandidate.species}</h3>

          <p>
            Similitud visual:{" "}
            <strong>{similarityLabel(topCandidate.similarity)}</strong>
          </p>

          <ol>
            {result.candidates.map((candidate) => (
              <li key={candidate.species}>
                {candidate.species} — similitud{" "}
                {candidate.similarity.toFixed(4)}
              </li>
            ))}
          </ol>

          <p>
            Resultado experimental. Requiere verificación antes de
            considerar una identificación confirmada.
          </p>
        </div>
      )}
    </section>
  );
}